import React, { Component } from "react";
import _, { isEmpty } from "lodash";
import { Sorters, CellRenderers, ColumnFilterTypes, startCaseWithSpace } from "utils/tableUtils";
import { parseURLSearch, updateURLSearch } from 'utils/urlUtil';
import TableContainerEvolved from "components/TableContainerEvolved";
import { Card, Typography, Button, Tooltip, notification, Switch, Divider} from "antd";
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import ScanAPI from "restAPI/ScanAPI";
import SubProductAPI from "restAPI/SubProductAPI";
import AppBreadcrumb from "components/AppBreadcrumb";
import Vocabulary from 'components/Vocabulary';
import UploadWidgetButton from "components/UploadWidget";
import { withRouter, NavLink } from 'react-router-dom';
import ActionMenuV2 from "components/ActionMenuV2";
import { RefreshIcon, DeleteIcon, InfoIcon, ExternalLinkIcon } from "components/Icons";
import EnvironmentName from "views/GlobalSettings/EnvironmentName";
import { PermissionSetMap } from 'constants/RBACConstants';
import DeletePopup from 'components/DeletePopup';
import ModalUtil from 'utils/modalUtil';
import { getStartAndEndDateForQuickOption } from "utils/dateUtils";
import moment from "moment/moment";
import { nativeRedirectionSupportedTools, fetchConfigAndRedirect, fetchConfigAndRedirectToToolUI } from "utils/securityToolUtil";
import ColumnFilterKeyValue from "components/ColumnFilterKeyValue";
import ColumnFilterGroups from "components/ColumnFilterGroups";
import { productFilterChanged } from "views/Insights/insightsUtils";
import { getProgress, SCAN_FINDING_LIST, ScanProgressIndicator, TRIGGER_BY_NAME_MAPPING } from "./ScanListProvider";
import ACButton from "ac-components/ac-button/ACButton";
import { ScanStatus } from "types/api/scanSummary";
import GiftIcon from "ac-components/ac-icons/GiftIcon";
import { setLocalStorage } from "utils/localStorageUtils";
import { withGlobalSettingsContext } from "contexts/GlobalSettingsContext";
import { withFeatureFlags } from "contexts/FeatureFlagContext";

const {Text} = Typography;

class ScanListing extends Component{
    static defaultProps = {
        onScanUploadSuccess: _.noop
    }
    tableRef = React.createRef();
    constructor(props){
        super(props);
        this.state = {
            scan: null,
            selectedRowKeys:[],
            pollingIds:[]
        }
        _.bindAll(
            this,
            "redirectToFindings",
            "onProgressChange",
            "onActionClick",
            "getAllScan",
            "onScanUploadSuccess",
            "getFilters"
        )
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
          const isProductFilterChanged = productFilterChanged(this.props.location.search, prevProps.location.search)
          if(isProductFilterChanged) {
            this.tableRef.refreshFilters();
          }
        }
      }

    progessBarImage = (record) => {
        return <ScanProgressIndicator record={record} onChange={this.onProgressChange} />
        
    }
    onProgressChange(){
        this.tableRef.refresh();
        this.tableRef.refreshFilters();
    }

    startPolling = async(id) => {
        const {pollingIds} = this.state;
        if(pollingIds.includes(id)){
            const params={id:id}
            const {content}=  await ScanAPI.getAll(params).promise;
            if(content[0].scanStatus === "COMPLETED" || content[0].scanStatus === "FAILED"){
                this.tableRef.refresh()
                return
            }else{
                pollingIds.splice(_.findIndex(pollingIds,id),1);
                setTimeout(()=>{
                    this.startPolling(id)
                },5000);
            }
        }else{
            pollingIds.push(id)
            this.startPolling(id);
        }
    }

    checkOnlyDuplicateFindings = (finding) => {
        return finding.totalFindings && finding.duplicateFindings && finding.totalFindings.count === finding.duplicateFindings.count;
    }

    scanIdRenderer = (text,record) => {
        const {
            findings: {
                newFindings: {
                    count: newFindingsCount = 0
                } = {}
            } = {},
            scanStatus
        } = record;
        const isDisabled = newFindingsCount <= 0;
        const clickHandler = () => {
            if(isDisabled || scanStatus !== ScanStatus.COMPLETED){
                return;
            }
            this.redirectToFindings(text, undefined, record);
        }
        return (
            <Button className='p-0' type="link" size="small" disabled={isDisabled} onClick={clickHandler} data-id={text}>{`S-${text}`}</Button>
        );
    }

    getCoulmns() {
        const hasDisabledEnvironment = !isEmpty(this.props.globalSettings.disabledEnvironment);
        const { toolName } = this.props;
        const columns = [{
            title:"Scan ID",
            dataIndex: "id",
            key: "id",
            width: 90,
            showSort: true,
            showFilter: true,
            onlySearch: true,
            sorter: Sorters.NUMBER("id"),
            render: this.scanIdRenderer,
            alwaysDisplay: true
        },{
            title: <Vocabulary name="product" />,
            dataIndex: "product",
            key: "product",
            showSort: true,
            showFilter: true,
            width:136,
            render: (text) => {
                if (text && text.name) {
                    return (
                        <NavLink to={`/product/${text.id}`} title={text.name}>
                            {text.name}
                        </NavLink>
                    );
                }
                return <Text>--</Text>;
            },
            optional: true,
            default: true,
            alwaysDisplay: false
        },{
            title: <Vocabulary name="subProduct" />,
            dataIndex: "subproduct",
            key: "subproduct",
            showSort: true,
            showFilter: true,
            width: 166,
            render: (text) => {
                if (text && text.name) {
                    return (
                        <NavLink to={`/subProduct/${text.id}`} title={text.name}>
                            {text.name}
                        </NavLink>
                    );
                }
                return <Text>--</Text>;
            },
            optional: true,
            default: true,
            alwaysDisplay: false
        },{
            title:"Environment",
            dataIndex: "environmentName",
            key: "environmentName",
            width:130,
            showSort: true,
            sorter: Sorters.STRING("environmentName"),
            render: (_, record) => <EnvironmentName name={record.environment} />,
            showFilter: !hasDisabledEnvironment,
            filterLabelFormatter: CellRenderers.VOCABULARY_RENDERER,
            optional: true,
            default: true,
            alwaysDisplay: false
        },...(_.isUndefined(toolName) ? [{
            title:"Source Tool",
            dataIndex: "source",
            key: "source",
            width:150,
            showSort: true,
            sorter: Sorters.STRING("source"),
            showFilter: true,
            optional: true,
            default: true,
            render: (tool, record) => {
                if(record.triggerby === "UI_UPLOAD"){
                    return record.tool;
                }
                return (
                  <>
                    <Typography.Link
                      onClick={() => {
                        fetchConfigAndRedirect({
                          toolName: record.tool,
                          productName: record.product.name,
                          subProductName: record.subproduct.name,
                          envName: record.environment,
                          history: this.props.history,
                        });
                      }}
                    >
                      {record.tool}
                    </Typography.Link>
                    {nativeRedirectionSupportedTools.includes(record.tool) && record.triggerby === "SCHEDULED" ? (
                      <Typography.Link
                        className="m-l-xs"
                        onClick={() => {
                          fetchConfigAndRedirectToToolUI({
                            toolName: record.tool,
                            productName: record.product.name,
                            subProductName: record.subproduct.name,
                            envName: record.environment,
                            history: this.props.history,
                          });
                        }}
                      >
                        <ExternalLinkIcon />
                      </Typography.Link>
                    ) : null}
                  </>
                );
            }
        }]: []),
        {
            title:"Scan Type",
            dataIndex: "scanType",
            key: "scanType",
            showFilter: true,
            width: 115,
            render: CellRenderers.TAGS,
            alwaysDisplay: false,
            nullFilterValue:'null'
        },
        {
            title: <>Ingestion Date<Tooltip title="ArmorCode Ingestion Date" placement='bottom'><InfoIcon className="m-l-xs" /></Tooltip></>,
            dataIndex: "createdAt",
            key: "createdAt",
            width:150,
            showSort: true,
            sorter: Sorters.NUMBER("createdAt"),
            render: CellRenderers.TIME_RELATIVE,
            showFilter: true,
            filterType: ColumnFilterTypes.DATE_RANGE,
            filterLabelFormatter: CellRenderers.DATE,
            optional: true,
            default: true,
            alwaysDisplay: false
        },
        {
            title: <>Last Tool Scan Date <Tooltip title="Last time the tool ran a scan on this project" placement='bottom'><InfoIcon /></Tooltip></>,
            dataIndex: "scanDate",
            key: "scanDate",
            width:150,
            showSort: true,
            sorter: Sorters.NUMBER("scanDate"),
            render: CellRenderers.DATE,
            showFilter: true,
            filterType: ColumnFilterTypes.DATE_RANGE,
            filterLabelFormatter: CellRenderers.DATE,
            optional: true,
            default: true,
        },{
            title: <>Total/Duplicate/Resolved/New Findings <Tooltip title="Total = Duplicate + New" ><InfoIcon /></Tooltip></>,
            dataIndex: "findings",
            key: "findings",
            showFilter: true,
            width:265,
            render:(text,record) => CellRenderers.AllFinding(text,record,this.redirectToFindings),
            filterLabelFormatter: (findings) => `${_.capitalize(findings)} > 0`,
            optional: true,
            default: true,
            alwaysDisplay: false
        },{
            title:"Scan Status",
            dataIndex: "scanStatus",
            key: "scanStatus",
            showFilter: true,
            filterLabelFormatter: _.capitalize,
            width: 115,
            showSort: true, 
            render: (text,record) => this.progessBarImage(record),
            alwaysDisplay: false
        },{
            title:"Trigger By",
            dataIndex: "triggerby",
            key: "triggerby",
            showFilter: true,
            showSort: true, 
            width:180,
            optional: true,
            default: true,
            alwaysDisplay: false,
            render: (text) => (TRIGGER_BY_NAME_MAPPING[text] || startCaseWithSpace(text)),
            filterLabelFormatter: (text) => (TRIGGER_BY_NAME_MAPPING[text] || startCaseWithSpace(text))
        },
        {
            title:"Tags",
            dataIndex: "tags",
            key: "tags",
            filterKey:"tags",
            width: 115,
            render: CellRenderers.TAGS,
            optional: true,
            default: true,
            alwaysDisplay: false,
            filterDropdown: (props) => <ColumnFilterKeyValue {...props} />,
            filterLabelFormatter: ColumnFilterKeyValue.filterLabelFormatter,
        },
        {
            title:"Scan Identifier",
            dataIndex: "scanIdentifier",
            key: "scanIdentifier",
            width: 115,
            showFilter: true,
            onlySearch: true,
            render: CellRenderers.VALUE_OR_NA,
            optional: true,
            default: true,
            alwaysDisplay: false
        },
        {
            title:"Uploaded By",
            dataIndex: "uploadedBy",
            key: "uploadedBy",
            width: 115,
            showFilter: true,
            onlySearch: true,
            render: CellRenderers.VALUE_OR_NA,
            optional: true,
            default: true,
            alwaysDisplay: false
        },
        {
            title: "Action",
            dataIndex: "action",
            key: 'action',
            width: 50,
            render: (text,record) => {
                const { progress } = getProgress(record.scanStatus);
                const { fileName: recordFileName } = record;
                const disableRedirect = !(progress > 66  && !this.checkOnlyDuplicateFindings(record.findings)) || progress <= 66;
                const tooltip = progress <= 66 ? `Scan ${_.capitalize(record.scanStatus)}` : (this.checkOnlyDuplicateFindings(record.findings) ? 'No new findings are found' : 'View result details')
                let exportReportToolTip = 'Export Report';
                if(typeof recordFileName === 'string' && recordFileName.trim() !== ''){
                    exportReportToolTip = `${exportReportToolTip} - ${recordFileName}`;
                }

                const items = [{
                    type: "resultDetail",
                    text: "Result Details",
                    icon: <EyeOutlined />,
                    tooltip: tooltip,
                    disabled: disableRedirect ? true : false
                  }, {
                    type: "exportReport",
                    text: "Export Report",
                    icon: <DownloadOutlined />,
                    tooltip: exportReportToolTip
                  },
                  {
                    type: "delete",
                    tooltip:"Delete Scans",
                    permission: PermissionSetMap.DELETE_SCAN
                  }
                ]
          
                  return (
                      <ActionMenuV2 items={items} onClick={this.onActionClick} data={{...record, disableRedirect, progress}} />
                  )
            },
            default: true
        }]
        return columns;
    }

    redirectToFindings(scanId, finding, record){
        const filters = {
            [finding === 'resolved' ? 'mitigatedByScanId' : 'scan']: [`${scanId}`],
            product: [record.product.id],
            subProduct: [record.subproduct.id],
            environmentName: [record.environment],
            ...(finding === 'resolved' && { issueResolved: [ moment(record.createdAt).utc().format(), moment().utc().format()] })
        }
        updateURLSearch(this.props.history, {
          filters,
          pagination:{
              page:0
          }
        }, "/findings");
      }

    onActionClick(name, record) {
        switch(record.name){
            case "resultDetail":
                !record.data?.disableRedirect && this.redirectToFindings(record.data?.id, undefined, record.data)
                break;
            case "exportReport":
               window.location.href = `/api/scans/${record.data?.id}/files`;
                break;
            case "delete":
                this.onDelete(record.data.id);
            break;
            default:
                break;
        }
    }
    onDelete = (id)=>{
        ScanAPI.deleteScan(id).promise.then(() => {
            notification.success({
                key:  new Date().toTimeString(),
                message: 'Scans delete is in progress',
                icon: <div />,
                description: (
                    <>Please check after some time.</>
                ),
            });
            this.onProgressChange();
            this.props.onScanUploadSuccess();
        }).catch(err => console.error(err))
    }
    onBulkDelete = () => {
        const { selectedRowKeys } = this.state;
        ModalUtil.show({
            content: (
                <DeletePopup 
                    promptMessage={<span>All the details related to this item will be permanently lost.<span className="text-bold">This can not be undone.</span></span>}
                    confirmText={"Delete"}
                    onDelete={()=>{
                        ScanAPI.bulkScansDelete(selectedRowKeys).promise.then(() => {
                            notification.success({
                                key:  new Date().toTimeString(),
                                message: 'Scans delete is in progress',
                                icon: <div />,
                                description: (
                                    <>Please check after some time.</>
                                ),
                            });
                            this.setState({ selectedRowKeys: [] })
                            this.onProgressChange()
                            this.props.onScanUploadSuccess();
                        }).catch(err => console.error(err))
                    }}
                />
            )
        })
    }
    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    };

    getAllScan(params) {
        const { toolName, scanName, triggerby } = this.props;
        const findingCounts =  params?.filters?.findings;
        // Generate queryparams object
        const filters = params.filters;

        if(filters?.id && filters.id[0]) {
            const id = filters.id[0];
            if(isNaN(id)) {
                if(id.match(/s-/gi)) {
                    filters.id[0] = id.split('-').pop();
                } else if(id === 's' || id === 'S') {
                    filters.id[0] = "";
                }
                if(filters.id[0] !== "" && isNaN(filters.id[0])){
                    filters.id[0] = -1;
                }
            }
        }
        if(filters?.createdAt && filters.createdAt.length === 1){
            filters.createdAt = getStartAndEndDateForQuickOption({
                label: filters.createdAt[0],
                utcString: true,
            });
        }

        if(filters?.scanDate && filters.scanDate.length === 1){
            filters.scanDate = getStartAndEndDateForQuickOption({
                label: filters.scanDate[0],
                utcString: true,
            });
        }

        if (filters?.tags) {

            filters.tags = _.map(filters.tags, tag => {
                const {key, value} = tag;
                let keyValue = key;
                if (value) {
                    keyValue = `${key}:${value}`;
                }
                return keyValue;
            });
        }

        const obj = {
            ...params.filters,
            findingCounts,
            ..._.omit(params, ["filters", "sortColumn", "sortOrder"]),
        }

        if(filters?.mostRecentScans) {
            obj.mostRecentScans = filters.mostRecentScans;
        }

        if(!_.isEmpty(toolName)) obj['tool'] = scanName || toolName;
        if(!_.isEmpty(triggerby)) obj['triggerby'] = triggerby;

        delete obj.findings;
        return ScanAPI.getAll(obj);
    }
      
    getFilters() {
        const { toolName, triggerby } = this.props;
        const { filters: { product } } = parseURLSearch(this.props.location.search)
        const { promise: promise1, cancel: cancel1 } = ScanAPI.getFilters({tool:toolName, triggerby})
        const { promise: promise2, cancel: cancel2 } = SubProductAPI.getAllQuick(product);

        const promise = Promise.all([promise1, promise2]).then(([filters, subProducts]) => {    
            const _allSubProductList = _.map(subProducts, subProduct => ({id: +subProduct.id, name: subProduct.name}));
            return {
                ...filters,
                scanStatus : filters.status,
                findings: SCAN_FINDING_LIST,
                environmentName: filters.environment,
                source: filters.tool,
                subproduct: _.intersectionBy(_allSubProductList, filters.subproduct, 'id')
            };
          }).catch(err => {
            console.error(err);
        });
        
        return {
            promise,
            cancel: () => {
              cancel1();
              cancel2();
            }
        };
    }
  
    onScanUploadSuccess(){
        this.tableRef.resetFilters();
        this.props.onScanUploadSuccess();
    }

    title = ()=> {
        const { selectedRowKeys } = this.state;
        return <span className="border border-radius p-x-xs">
           <span className="border-right p-r-xs">Selected {selectedRowKeys.length}</span>
           <Tooltip title="Delete"><DeleteIcon className="danger m-l-xs clickable" onClick={this.onBulkDelete}/></Tooltip>
        </span>
    }

    enableNewScanView = () => {
        setLocalStorage("NEW_SCANS_VIEW", true);
        window.location.reload();
    }

    renderScanList = () => {
        const { toolName, tableKey = "scans-list-table", scanInfo } = this.props;
        const rowSelection = {
            selectedRowKeys:this.state.selectedRowKeys,
            columnWidth: 30,
            onChange: this.onSelectChange,
          };
        
          const { filters, pagination } = parseURLSearch(this.props.history.location.search);
          const mostRecentScans = filters.mostRecentScans;
          const extras = <>
          <>
          {scanInfo && <><span className='success'>{scanInfo}</span> <Divider type="vertical" className="m-0" /></>}
            <Switch size="small" onChange={(checked) => {
                updateURLSearch(this.props.history, {
                  filters: { ...filters, mostRecentScans: checked },
                  pagination: { ...pagination, page: 0 },
                });
            }} checked={mostRecentScans} />Only show most recent scans
          </>
          <Divider type="vertical" className="m-0" />
          <UploadWidgetButton onScanSuccess={this.onScanUploadSuccess} tools={ toolName }/>
        </>;  
        const extraFilter = [{
            title: <Vocabulary name="group" />,
            dataIndex: "groups",
            filterDropdown: props => <ColumnFilterGroups {...props} />,
            filterLabelFormatter: ColumnFilterGroups.filterLabelFormatter,
        }];
        return (
          <>
            <TableContainerEvolved
                sticky
                tableKey={tableKey}
                title={!_.isEmpty(this.state.selectedRowKeys) && this.title()}
                api={this.getAllScan}
                rowSelection={rowSelection}
                columns={this.getCoulmns()}
                showAdvanceFilter={true}
                defaultFilter={{
                    findings: ["NEW"]
                }}
                enableScroll
                storeSessionFilter={true}
                filtersApi={this.getFilters}
                tableRef={tableRef => this.tableRef = tableRef}
                defaultSort={{sortColumn: "createdAt", sortOrder: "descend"}}
                extras={extras}
                columnsReorder={true}
                showTotal
                extraFilter={extraFilter}
                ignoreFiltersOnReset={["mostRecentScans"]}
            />
          </>
        )
    }

    render(){
       
        const { toolName } = this.props;
        return (
          <>
            {_.isUndefined(toolName) && (
              <>
                <div className="pull-right">
                  <ACButton
                    size="sm"
                    type="secondary"
                    onClick={this.enableNewScanView}
                  >
                    <GiftIcon /> Preview New Scans Page
                  </ACButton>
                  <Button
                    type="text"
                    title="Refresh"
                    size="small"
                    onClick={() => {
                      this.tableRef.refresh();
                      this.tableRef.refreshFilters();
                    }}
                  >
                    {" "}
                    <Tooltip placement="bottom" title="Refresh">
                      <RefreshIcon />
                    </Tooltip>
                  </Button>
                </div>
                <AppBreadcrumb crumbs={["Scans"]} />
              </>
            )}
            {_.isUndefined(toolName) ? (
              <Card size="small" bodyStyle={{ paddingBottom: 0 }}>
                {this.renderScanList()}
              </Card>
            ) : (
              this.renderScanList()
            )}
          </>
        );
    }
}

export default withGlobalSettingsContext(withFeatureFlags(withRouter(ScanListing)));

export {
    ScanListing as ScanListTable
}